import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { N500 } from '@atlaskit/theme/colors';

import { messages } from '../../messages';

export const SocialSignUpDivider = () => {
  return (
    <SocialSignUpDividerLabel>
      <SocialSignUpDividerLeftline />
      <FormattedMessage {...messages.socialSignUpDividerLabel} />
      <SocialSignUpDividerRightline />
    </SocialSignUpDividerLabel>
  );
};

const fontCharlieText =
  '"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",' +
  'Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';

const SocialSignUpDividerLabel = styled.div`
  font-family: ${fontCharlieText};
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${N500};
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
`;
const SocialSignUpDividerLeftline = styled.div`
  border-bottom: 1px solid #d8d8d8;
  width: 31px;
  margin-right: 8px;
`;
const SocialSignUpDividerRightline = styled.div`
  border-bottom: 1px solid #d8d8d8;
  width: 31px;
  margin-left: 8px;
`;
